var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIconLined(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_620_6386)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_620_6386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.79736 4.15039H3.1913H14.3428",
    stroke: "#262626",
    strokeWidth: 1.15152,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28232 4.15116V2.75722C5.28232 2.38753 5.42917 2.03297 5.69059 1.77156C5.95201 1.51014 6.30656 1.36328 6.67625 1.36328H9.46413C9.83381 1.36328 10.1884 1.51014 10.4498 1.77156C10.7112 2.03297 10.8581 2.38753 10.8581 2.75722V4.15116M12.949 4.15116V13.9087C12.949 14.2784 12.8021 14.633 12.5407 14.8944C12.2793 15.1558 11.9247 15.3027 11.555 15.3027H4.58535C4.21565 15.3027 3.8611 15.1558 3.59968 14.8944C3.33826 14.633 3.19141 14.2784 3.19141 13.9087V4.15116H12.949Z",
    stroke: "#262626",
    strokeWidth: 1.15152,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.67627 7.63672V11.8185",
    stroke: "#262626",
    strokeWidth: 1.15152,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46436 7.63672V11.8185",
    stroke: "#262626",
    strokeWidth: 1.15152,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_620_6386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_620_6386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.1404,
    height: 15.3333,
    fill: "white",
    transform: "translate(0 0.666016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconLined);
export default __webpack_public_path__ + "static/media/DeleteIconLined.e510581668a8d27f9d287ef1e937348d.svg";
export { ForwardRef as ReactComponent };